import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import { StyledSelect } from 'lib/styles';

const Container = styled.div`
	margin: 0 0 40px 0;
`;

const Label = styled.p`
	font-size: 12px;
	color: #9B9B9B;
	margin: 0 0 8px;
`;

class Layout extends React.Component {
	state = {
	  layout: this.props.layout,
	}

	shouldComponentUpdate(nextProps) {
	  return this.props.layout !== nextProps.layout;
	}

	changeHandler = layout => {
	  this.setState({ layout });
	  this.props.updateSettingsHandler({
	    layout
	  })
	}

	render() {
	  const { t } = this.props;
	  return (
	    <Container>
	      <Label>{t('controls/common/settings/layout')}</Label>
	      <StyledSelect
	        id="layout"
	        defaultValue={this.state.layout}
	        style={{ width: '100%' }}
	        options={[
	          {
	            value: 'default',
	            name: t('controls/text/settings/layout/default'),
	          },
	          {
	            value: 'centered',
	            name: t('controls/text/settings/layout/centered'),
	          },
	          {
	            value: 'top-centered',
	            name: t('controls/text/settings/layout/top-centered'),
	          },
	          {
	            value: 'bottom-centered',
	            name: t('controls/text/settings/layout/bottom-centered'),
	          },
	          {
	            value: 'left-centered',
	            name: t('controls/text/settings/layout/left-centered'),
	          }
	        ]}
	        onChange={e => this.changeHandler(e.target.value)}
	      />
	    </Container>
	  )
	}
}

Layout.propTypes = {
	t: PropTypes.func,
	updateSettingsHandler: PropTypes.func,
	layout: PropTypes.string,
}

export default translate('translations')(Layout)
